// 부르는 쪽의 API 오류는 모양이 제각각이라(ApiError·Error·문자열) 여기서 문장 하나로 접는다.
// 서버가 준 문장이 있으면 그것이 먼저다 — 거절 문장은 서버가 한 벌로 들고 있고 화면은 읽기만 한다.
export function errorMessage(err: unknown, fallback: string): string {
  if (err instanceof Error && err.message) return err.message;
  if (typeof err === "string" && err) return err;
  return fallback;
}
